import {
  avatar1Img,
  avatar2Img,
  avatar3Img,
  avatar4Img,
  avatar5Img,
  avatar6Img,
  avatar7Img,
  avatar8Img,
  avatar9Img,
  avatar10Img,
  restaurant1Img,
  restaurant2Img,
  restaurant3Img,
  restaurant4Img,
  restaurant5Img,
  restaurant6Img,
  restaurant7Img,
  restaurant8Img,
  masterPaymentImg,
  paypalPaymentImg,
  rupayPaymentImg,
  visaPaymentImg,
} from "./images";
import { subtractHours } from "@/utils";

export const consumerReviews = [
  {
    id: 301,
    reviewer_name: "Will Byers",
    reviewer_image: avatar1Img,
    stars: 5,
    review:
      "Food is the best. Besides the many and delicious meals, the service is also very good, especially in the very fast delivery. I highly recommend Food to you.",
  },
  {
    id: 302,
    reviewer_name: "Mike Wheeler",
    reviewer_image: avatar2Img,
    stars: 4.5,
    review:
      "Yum is probably one of the best options when it comes to food delivery when living in DLF phase 3, or in the delivery range.",
  },
  {
    id: 303,
    reviewer_name: "Lucas Sinclair",
    reviewer_image: avatar3Img,
    stars: 5,
    review:
      "Quality, Quantity, Packaging, Delivery Time & Taste are quintessential factors when one orders a home delivery. The people at Caters Point know how to deliver all to a nicety & perfection 😊",
  },
  {
    id: 304,
    reviewer_name: "Steve Harrington",
    reviewer_image: avatar4Img,
    stars: 5,
    review:
      'The food of the place is really awesome with a special menu item might be seasonal "Mango broccoli sandwich" which is really something you should give a shot. The sandwich is filled with cottage cheese, Mango and broccoli layer with more add-on toppings in it.',
  },
];

export const cardsData = [
  {
    id: 501,
    card_holder_name: "Sansa Stark",
    cardNo: 1234567895123647,
    expiry_date: "10/23",
    provider: visaPaymentImg,
  },
  {
    id: 502,
    card_holder_name: "Jon Snow",
    cardNo: 1234567981953452,
    expiry_date: "10/28",
    provider: masterPaymentImg,
  },
  {
    id: 503,
    card_holder_name: "Arya Stark",
    cardNo: 6457986452137985,
    expiry_date: "21/25",
    provider: rupayPaymentImg,
  },
  {
    id: 504,
    card_holder_name: "Petyr Baelish",
    cardNo: 7897892314651231,
    expiry_date: "30/31",
    provider: paypalPaymentImg,
  },
];

export const restaurantsData = [
  {
    id: 901,
    sellerid: 701,
    name: "Healthy Feast Corner",
    total_dishes: 34,
    total_sales: 425,
    address:
      "2123 Osprey the Blue Mountains, Townline, Feversham, ON NOC 1CO, Canada",
    categories: [1, 2],
    logo: restaurant1Img,
    contact_no: 1078832848,
    email: "hbruggen0@narod.ru",
  },
  {
    id: 902,
    sellerid: 702,
    name: "Farmhouse Dish Heaven",
    total_dishes: 12,
    total_sales: 1234,
    address: "2045 Scotch Line, Essa, Ontario, L9R 1V2, Alliston, CA",
    categories: [2, 3],
    logo: restaurant2Img,
    contact_no: 2847899814,
    email: "dsoden1@fda.gov",
  },
  {
    id: 903,
    sellerid: 703,
    name: "Kitchen Creation",
    total_dishes: 14,
    total_sales: 42,
    address: "6058 Townhigh Mountains, Sideroad, Clarksburg, ON.",
    categories: [4, 5],
    logo: restaurant3Img,
    contact_no: 2816686226,
    email: "lhillen2@dyndns.org",
  },
  {
    id: 904,
    sellerid: 704,
    name: "Country Cooking Cove",
    total_dishes: 53,
    total_sales: 2452,
    address: "A-67 Concession 8, Nottawasaga RD, Glen Huron, Poland",
    categories: [5, 6],
    logo: restaurant4Img,
    contact_no: 1102607941,
    email: "knewsome3@alexa.com",
  },
  {
    id: 905,
    sellerid: 705,
    name: "Gourmet Flavor nook",
    total_dishes: 50,
    total_sales: 1506,
    address:
      "2123 Osprey the Blue Mountains, Townline, Feversham, ON NOC 1CO, Canada",
    categories: [6, 7],
    logo: restaurant5Img,
    contact_no: 9422719236,
    email: "rsclater4@nydailynews.com",
  },
  {
    id: 906,
    sellerid: 706,
    name: "Culinary Craft Cabin",
    total_dishes: 10,
    total_sales: 1052,
    address: "3,4 - Twilight Bungalows, Sideroad, Clarksburg, Russia",
    categories: [7, 1],
    logo: restaurant6Img,
    contact_no: 6692668539,
    email: "apluthero5@tuttocitta.it",
  },
  {
    id: 907,
    sellerid: 707,
    name: "Rustic Spice Shack",
    total_dishes: 15,
    total_sales: 257,
    address: "1003 Nusha Apartment, Townline st., Helsinki, NGC Road , Finland",
    categories: [6, 2],
    logo: restaurant7Img,
    contact_no: 4667129090,
    email: "wconew6@qq.com",
  },
  {
    id: 908,
    sellerid: 708,
    name: "Savory Bites Cafe",
    total_dishes: 28,
    total_sales: 357,
    address: "784 Flowsome Avenue st., Shine Road, Sa Francisco , USA 547215",
    categories: [5, 3],
    logo: restaurant8Img,
    contact_no: 4102508252,
    email: "cbogies7@disqus.com",
  },
];

export const sellersData = [
  {
    id: 701,
    name: "Hollie Bruggen",
    photo: avatar1Img,
    contact_no: 1078832848,
    email: "hbruggen0@narod.ru",
    location: "Mae Lan",
    order_total: 40486.29,
    orders: 17,
    joining_date: "01/21/2023",
    joining_time: "19:54",
    status: "active",
  },
  {
    id: 702,
    name: "Delainey Soden",
    photo: avatar2Img,
    contact_no: 2847899814,
    email: "dsoden1@fda.gov",
    location: "Guaxupé",
    order_total: 15685.72,
    orders: 3,
    joining_date: "10/15/2023",
    joining_time: "17:34",
    status: "blocked",
  },
  {
    id: 703,
    name: "Lou Hillen",
    photo: avatar3Img,
    contact_no: 2816686226,
    email: "lhillen2@dyndns.org",
    location: "Houston",
    order_total: 46501.82,
    orders: 7,
    joining_date: "10/28/2023",
    joining_time: "12:08",
    status: "active",
  },
  {
    id: 704,
    name: "Karlyn Newsome",
    photo: avatar4Img,
    contact_no: 1102607941,
    email: "knewsome3@alexa.com",
    location: "Gaoyan",
    order_total: 13199.92,
    orders: 6,
    joining_date: "03/18/2023",
    joining_time: "14:57",
    status: "active",
  },
  {
    id: 705,
    name: "Roley Sclater",
    photo: avatar5Img,
    contact_no: 9422719236,
    email: "rsclater4@nydailynews.com",
    location: "Yushan",
    order_total: 5154.24,
    orders: 2,
    joining_date: "01/29/2023",
    joining_time: "6:39",
    status: "active",
  },
  {
    id: 706,
    name: "Amelie Pluthero",
    photo: avatar6Img,
    contact_no: 6692668539,
    email: "apluthero5@tuttocitta.it",
    location: "Lundazi",
    order_total: 48316.18,
    orders: 13,
    joining_date: "06/05/2023",
    joining_time: "17:28",
    status: "blocked",
  },
  {
    id: 707,
    name: "Wilden Conew",
    photo: avatar7Img,
    contact_no: 4667129090,
    email: "wconew6@qq.com",
    location: "Gaplokan",
    order_total: 26413.79,
    orders: 14,
    joining_date: "04/22/2023",
    joining_time: "9:54",
    status: "active",
  },
  {
    id: 708,
    name: "Coreen Bogies",
    photo: avatar8Img,
    contact_no: 4102508252,
    email: "cbogies7@disqus.com",
    location: "Kaparéllion",
    order_total: 36832.55,
    orders: 6,
    joining_date: "06/06/2023",
    joining_time: "19:27",
    status: "active",
  },
  {
    id: 709,
    name: "Hanan Bream",
    photo: avatar9Img,
    contact_no: 5999053063,
    email: "hbream8@furl.net",
    location: "Kisai",
    order_total: 956.37,
    orders: 15,
    joining_date: "12/07/2022",
    joining_time: "4:17",
    status: "blocked",
  },
  {
    id: 710,
    name: "Adriane Arnout",
    photo: avatar10Img,
    contact_no: 3745303922,
    email: "aarnout9@ezinearticles.com",
    location: "Knin",
    order_total: 20359.75,
    orders: 14,
    joining_date: "06/01/2023",
    joining_time: "18:53",
    status: "blocked",
  },
  {
    id: 711,
    name: "Meggy Powdrill",
    photo: avatar1Img,
    contact_no: 3947283261,
    email: "mpowdrill0@fastcompany.com",
    location: "Macroom",
    order_total: 39589.79,
    orders: 11,
    joining_date: "04/25/2023",
    joining_time: "14:29",
    status: "active",
  },
  {
    id: 712,
    name: "Babita Hackleton",
    photo: avatar2Img,
    contact_no: 2463052051,
    email: "bhackleton1@hp.com",
    location: "Bebekan",
    order_total: 19563.94,
    orders: 16,
    joining_date: "05/17/2023",
    joining_time: "0:00",
    status: "active",
  },
  {
    id: 713,
    name: "Zollie Robic",
    photo: avatar3Img,
    contact_no: 3095871965,
    email: "zrobic2@blinklist.com",
    location: "Myhove",
    order_total: 44561.68,
    orders: 6,
    joining_date: "07/02/2023",
    joining_time: "22:35",
    status: "blocked",
  },
  {
    id: 714,
    name: "Val Pendre",
    photo: avatar4Img,
    contact_no: 1124961590,
    email: "vpendre3@cmu.edu",
    location: "Dengteke",
    order_total: 12050.91,
    orders: 9,
    joining_date: "02/27/2023",
    joining_time: "2:08",
    status: "active",
  },
  {
    id: 715,
    name: "Chrissy Schiersch",
    photo: avatar5Img,
    contact_no: 6744085415,
    email: "cschiersch4@stumbleupon.com",
    location: "Bidikotak",
    order_total: 44907.68,
    orders: 14,
    joining_date: "10/29/2023",
    joining_time: "13:59",
    status: "blocked",
  },
  {
    id: 716,
    name: "Jesus McGarahan",
    photo: avatar6Img,
    contact_no: 9133735168,
    email: "jmcgarahan5@hugedomains.com",
    location: "Sakassou",
    order_total: 2532.5,
    orders: 18,
    joining_date: "10/09/2023",
    joining_time: "20:18",
    status: "active",
  },
  {
    id: 717,
    name: "Caleb Patters",
    photo: avatar7Img,
    contact_no: 4321051127,
    email: "cpatters6@aboutads.info",
    location: "Novobeysugskaya",
    order_total: 25450.93,
    orders: 2,
    joining_date: "05/30/2023",
    joining_time: "3:05",
    status: "active",
  },
  {
    id: 718,
    name: "Ambros Kemish",
    photo: avatar8Img,
    contact_no: 2393277306,
    email: "akemish7@etsy.com",
    location: "Puerto Berrío",
    order_total: 25960.05,
    orders: 15,
    joining_date: "01/01/2023",
    joining_time: "8:16",
    status: "active",
  },
  {
    id: 719,
    name: "Harrison Delouch",
    photo: avatar9Img,
    contact_no: 2459796196,
    email: "hdelouch8@chicagotribune.com",
    location: "Bolesławiec",
    order_total: 25561.23,
    orders: 10,
    joining_date: "04/23/2023",
    joining_time: "2:00",
    status: "active",
  },
  {
    id: 720,
    name: "Joshuah Mc Giffin",
    photo: avatar10Img,
    contact_no: 3232909553,
    email: "jmc9@forbes.com",
    location: "Krasnoye",
    order_total: 2399.89,
    orders: 12,
    joining_date: "11/26/2023",
    joining_time: "2:41",
    status: "blocked",
  },
];

export const orderHistoryData = [
  {
    date: "12/03/2022",
    id: "#c0e4f7",
    amount: 359.69,
    status: "refunded",
    dishid: 1001,
  },
  {
    date: "04/25/2023",
    id: "#12939f",
    amount: 350.3,
    status: "paid",
    dishid: 1002,
  },
  {
    date: "06/20/2023",
    id: "#9f36ca",
    amount: 67.99,
    status: "cancelled",
    dishid: 1003,
  },
  {
    date: "03/02/2023",
    id: "#a657a0",
    amount: 21.49,
    status: "paid",
    dishid: 1005,
  },
  {
    date: "05/05/2023",
    id: "#8cd211",
    amount: 463.61,
    status: "refunded",
    dishid: 1004,
  },
  {
    date: "06/07/2023",
    id: "#5191a8",
    amount: 333.31,
    status: "refunded",
    dishid: 1006,
  },
  {
    date: "08/23/2023",
    id: "#6af783",
    amount: 391.0,
    status: "paid",
    dishid: 1007,
  },
  {
    date: "05/02/2023",
    id: "#a6c5aa",
    amount: 150.63,
    status: "paid",
    dishid: 1008,
  },
  {
    date: "05/22/2023",
    id: "#b07041",
    amount: 24.81,
    status: "cancelled",
    dishid: 1009,
  },
  {
    date: "04/13/2023",
    id: "#94516a",
    amount: 72.21,
    status: "paid",
    dishid: 1010,
  },
];

export const transactionHistoryData = [
  {
    asset: "King Group",
    date: "10/14/2023",
    amount: 359.69,
    type: "shopping",
    status: "cancelled",
  },
  {
    asset: "Rath-Hickle",
    date: "03/01/2023",
    amount: 350.3,
    type: "shopping",
    status: "paid",
  },
  {
    asset: "Weimann-Botsford",
    date: "03/14/2023",
    amount: 67.99,
    type: "food",
    status: "refunded",
  },
  {
    asset: "Prohaska LLC",
    date: "08/31/2023",
    amount: 21.49,
    type: "grocery",
    status: "paid",
  },
  {
    asset: "Rath-Conroy",
    date: "10/10/2023",
    amount: 463.61,
    type: "shopping",
    status: "cancelled",
  },
  {
    asset: "Balistreri, Toy and Padberg",
    date: "11/16/2023",
    amount: 333.31,
    type: "food",
    status: "paid",
  },
  {
    asset: "Kling and Sons",
    date: "10/14/2023",
    amount: 391.0,
    type: "shopping",
    status: "refunded",
  },
  {
    asset: "Sawayn-Streich",
    date: "04/04/2023",
    amount: 150.63,
    type: "grocery",
    status: "paid",
  },
  {
    asset: "Pacocha, Christiansen and Feil",
    date: "06/24/2023",
    amount: 24.81,
    type: "food",
    status: "refunded",
  },
  {
    asset: "Sipes, Olson and Dare",
    date: "04/30/2023",
    amount: 72.21,
    type: "restaurant",
    status: "paid",
  },
  {
    asset: "Dickinson-Daugherty",
    date: "01/02/2023",
    amount: 199.05,
    type: "restaurant",
    status: "cancelled",
  },
  {
    asset: "Shanahan, Kassulke and O'Hara",
    date: "07/23/2023",
    amount: 240.06,
    type: "shopping",
    status: "paid",
  },
  {
    asset: "Boehm-Metz",
    date: "08/29/2023",
    amount: 147.2,
    type: "food",
    status: "paid",
  },
  {
    asset: "O'Keefe, Hirthe and Leannon",
    date: "01/27/2023",
    amount: 125.14,
    type: "shopping",
    status: "cancelled",
  },
  {
    asset: "VonRueden, Leffler and Pacocha",
    date: "01/10/2023",
    amount: 167.64,
    type: "restaurant",
    status: "paid",
  },
];

export const analyticsOverviewData = [
  {
    name: "Total Revenue",
    amount: 325684,
    change: "10% Increase",
  },
  {
    name: "New Orders",
    amount: 2560,
    change: "50% Increase",
  },
  {
    name: "Received Orders",
    amount: 12560,
    change: "34% Increase",
  },
  {
    name: "Reviews",
    amount: 476,
    change: "5% Decrease",
  },
  {
    name: "New Reach",
    amount: 865,
    change: "48% Increase",
  },
  {
    name: "Successful Orders",
    amount: 9165,
    change: "8% Decrease",
  },
];

export const adminDishListData = [
  {
    dishid: 1001,
    create_by: "Admin",
    status: "published",
  },
  {
    dishid: 1002,
    create_by: "Restaurant",
    status: "published",
  },
  {
    dishid: 1003,
    create_by: "Admin",
    status: "published",
  },
  {
    dishid: 1004,
    create_by: "Admin",
    status: "draft",
  },
  {
    dishid: 1005,
    create_by: "Admin",
    status: "reviewing",
  },
  {
    dishid: 1006,
    create_by: "Restaurant",
    status: "published",
  },
  {
    dishid: 1007,
    create_by: "Admin",
    status: "published",
  },
  {
    dishid: 1008,
    create_by: "Admin",
    status: "published",
  },
  {
    dishid: 1009,
    create_by: "Admin",
    status: "draft",
  },
  {
    dishid: 1010,
    create_by: "Admin",
    status: "published",
  },
];

export const orderProgressData = {
  waiting: [
    {
      orderid: "#c0e4f7",
      time: "6.25 AM",
    },
    {
      orderid: "#12939f",
      time: "6.25 AM",
    },
  ],
  cooking: [
    {
      orderid: "#9f36ca",
      time: "6.25 AM",
    },
    {
      orderid: "#94516a",
      time: "6.25 AM",
    },
  ],
  packed: [
    {
      orderid: "#5191a8",
      time: "08.30 PM",
    },
  ],
};

export const dishTags = [
  "Pizza",
  "Burger",
  "Cake",
  "Desserts",
  "Coffee & Tea",
  "Juices",
  "Italian Food",
  "Beverages",
  "Noodles",
  "Momos",
  "Sandwich",
  "Frankie",
];

export const notificationsData = [
  {
    id: 1,
    name: "Datacorp",
    avatar: avatar1Img,
    subText: "Caleb Flakelar commented on Admin",
    createdAt: subtractHours(new Date(), 1),
  },
  {
    id: 2,
    name: "Admin",
    avatar: avatar2Img,
    subText: "New user registered",
    createdAt: subtractHours(new Date(), 60),
  },
  {
    id: 3,
    name: "Cristina Pride",
    subText: "Hi, How are you? What about our next meeting",
    avatar: avatar3Img,
    createdAt: subtractHours(new Date(), 120),
  },
  {
    id: 4,
    name: "Datacorp",
    avatar: avatar4Img,
    subText: "Caleb Flakelar commented on Admin",
    createdAt: subtractHours(new Date(), 1440),
  },
  {
    id: 5,
    name: "Karen Robinson",
    subText: "Wow ! this admin looks good and awesome design",
    avatar: avatar5Img,
    createdAt: subtractHours(new Date(), 1820),
  },
];

export const categorieListData = [
  {
    id: 701,
    name: "Pizza",
    picture: avatar1Img,
    joining_date: "01/21/2023",
    joining_time: "19:54",
    status: "true",
  },
  {
    id: 702,
    name: "Burger",
    picture: avatar2Img,
    joining_date: "10/15/2023",
    joining_time: "17:34",
    status: "false",
  },
  {
    id: 703,
    name: "Cake",
    picture: avatar3Img,
    joining_date: "10/28/2023",
    joining_time: "12:08",
    status: "true",
  },
  {
    id: 704,
    name: "Desserts",
    picture: avatar4Img,
    joining_date: "03/18/2023",
    joining_time: "14:57",
    status: "true",
  },
  {
    id: 705,
    name: "Coffee & Tea",
    picture: avatar5Img,
    joining_date: "01/29/2023",
    joining_time: "6:39",
    status: "true",
  },
  {
    id: 706,
    name: "Juices",
    picture: avatar6Img,
    joining_date: "06/05/2023",
    joining_time: "17:28",
    status: "false",
  },
  {
    id: 707,
    name: "Italian Food",
    picture: avatar7Img,
    joining_date: "04/22/2023",
    joining_time: "9:54",
    status: "true",
  },
  {
    id: 708,
    name: "Beverages",
    picture: avatar8Img,
    joining_date: "06/06/2023",
    joining_time: "19:27",
    status: "true",
  },
];
